import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getNotificationEventValues = (eventId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.GET_NOTIFICATION_EVENT_VALUES(eventId)
  );
};

export default getNotificationEventValues;
